import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import { AppUrls } from 'routes/app-urls';
import { CompanySubscriptionWrap } from 'routes/company-subscription-wrap';
import { NotFoundPage, BillingNoticePage } from 'unit-error-pages/pages';
import { CompanyManagementPage } from 'unit-people/pages/company-management';
import { CompanySubscriptionParams } from './route-params';
import { Urls } from './urls';


export class Routes extends React.Component<RouteComponentProps<CompanySubscriptionParams>> {
  public render(): JSX.Element {
    const { type: subscriptionType, companyId } = this.props.match.params;
    const isSubscriptionBlock = true;


    return (
      <CompanySubscriptionWrap
        subscriptionType={subscriptionType}
        companyId={+companyId}
        ownCompanyPath={AppUrls.subscription.index}
      >
        <Switch>
          <Route exact={true} path={Urls.manageCompany.path} component={CompanyManagementPage} />
        </Switch>
        {isSubscriptionBlock && this.renderBillingNoticePage()}
      </CompanySubscriptionWrap>
    );
  }

  private renderBillingNoticePage(): JSX.Element {

    return (
      <Switch>
        <Route
          path={Urls.billingNotice.path}
          exact={true}
          metaTitle='Billing Notice'
          component={BillingNoticePage}
        />
        <Redirect to={Urls.billingNotice.locationWithCurrentQuery()}/>
        <Route component={NotFoundPage} />
      </Switch>
    );
  }
}
